var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgJobs = function SvgJobs(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.103,
    height: 16.237,
    viewBox: "0 0 17.103 16.237",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "briefcase_1_",
    "data-name": "briefcase (1)",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18947",
    "data-name": "Path 18947",
    d: "M158.452,1.727a.7.7,0,0,1,.7-.7h3.131a.7.7,0,0,1,.7.7V2.3h1.03V1.727A1.729,1.729,0,0,0,162.28,0h-3.131a1.729,1.729,0,0,0-1.727,1.727V2.3h1.03Zm0,0",
    transform: "translate(-152.164 0)",
    fill: "#adafb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18948",
    "data-name": "Path 18948",
    d: "M13.295,259.469v.728a.515.515,0,0,1-1.03,0v-.728H4.838v.728a.515.515,0,1,1-1.03,0v-.728H0v5.905a1.667,1.667,0,0,0,1.665,1.665H15.438a1.667,1.667,0,0,0,1.665-1.665v-5.905Zm0,0",
    transform: "translate(0 -250.802)",
    fill: "#adafb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18949",
    "data-name": "Path 18949",
    d: "M3.809,103.984v-.728a.515.515,0,1,1,1.03,0v.728h7.427v-.728a.515.515,0,0,1,1.03,0v.728H17.1v-2.643a1.667,1.667,0,0,0-1.665-1.665H1.666A1.667,1.667,0,0,0,0,101.341v2.643Zm0,0",
    transform: "translate(-0.001 -96.346)",
    fill: "#adafb3"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJobs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/jobs.4dbf5429.svg";
export { ForwardRef as ReactComponent };